import RadioGroup from '../../../components/RadioGroup/RadioGroup'
import { SPLIT_FEES_OPTIONS, SplitFeesRouting } from './constants'
import { useEffect, useState, useMemo } from 'react'
import useRouter from '../../../hooks/useRouter'
import { LedByGPO } from '../AdminSplitFees/GPO/LedByGPO'
import { LedByCommunity } from '../AdminSplitFees/Community/LedByCommunity'
import { ReactComponent as Close16 } from '../../../assets/svg/Clos16.svg'
import { GPO_SUBTABS } from '../AdminSplitFees/constants'
import { ReactComponent as Search16 } from '../../../assets/svg/Search16.svg'
import { Input } from '../../../components/Input'
import { useSelector } from 'react-redux'
import { getUser } from '../../../redux/store/user/getters'
import { ACTIONS, contractSubject, defineAbility, SUBJECTS } from '../Abilities'
import { CommunityProcessing } from './CommunityProcessing/CommunityProcessing'

export const SplitFees = () => {
  const { query, push, location } = useRouter()
  const [searchValue, setSearchValue] = useState('')

  const user = useSelector(getUser)
  const ability = useMemo(() => defineAbility(user), [user])

  const subTabsOptions = useMemo(() => {
    const tabSubjectByValue = {
      [SplitFeesRouting.gpo]: SUBJECTS.SPLIT_FEES_GPO_TAB,
      [SplitFeesRouting.community]: SUBJECTS.SPLIT_FEES_COMMUNITY_TAB,
      [SplitFeesRouting.processing]: SUBJECTS.SPLIT_FEES_PROCESSING_TAB
    }
    const visibleOptions = SPLIT_FEES_OPTIONS.filter((option) =>
      ability.can(
        ACTIONS.VIEW,
        contractSubject(tabSubjectByValue[option.value], user)
      )
    )
    //TODO: refactor sub tabs to allow empty state
    return visibleOptions.length ? visibleOptions : [{ label: '', value: '' }]
  }, [ability, user])

  const [activeSubTab, setActiveSubTab] = useState(
    query?.subtab || subTabsOptions[0].value
  )

  const handleTabs = (e) => {
    setSearchValue('')
    setActiveSubTab(e)
    push(e)
  }

  useEffect(() => {
    subTabsOptions.find((tab) => {
      if (location?.pathname?.includes(tab.value)) {
        setActiveSubTab(tab.value)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!subTabsOptions.some((tab) => tab.value === activeSubTab)) {
      handleTabs(subTabsOptions[0].value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subTabsOptions, activeSubTab])

  return (
    <div className="split-fees-container">
      <div className="mb-24 row gap-24 space-between">
        <RadioGroup.Buttons
          options={subTabsOptions}
          defaultValue={activeSubTab}
          onChange={handleTabs}
          className="mt-0"
        />
        {(activeSubTab === SplitFeesRouting.gpo ||
          activeSubTab === SplitFeesRouting.community) && (
          <Input
            className="allow-clear"
            propsInput={{
              allowClear: { clearIcon: <Close16 /> },
              placeholder: `Search by ${
                activeSubTab === GPO_SUBTABS[0].value ? 'GPO' : 'Community'
              } name`,
              prefix: <Search16 />,
              value: searchValue,
              onChange: (e) => setSearchValue(e.target.value)
            }}
            propsItem={{
              style: {
                width: 364
              }
            }}
          />
        )}
      </div>
      {activeSubTab === SplitFeesRouting.gpo && (
        <LedByGPO search={searchValue} />
      )}
      {activeSubTab === SplitFeesRouting.community && (
        <LedByCommunity search={searchValue} />
      )}
      {activeSubTab === SplitFeesRouting.processing && <CommunityProcessing />}
    </div>
  )
}
